<template>
  <div>
    <template v-if="puescData.can_integrate">
      <d-alert
        v-if="orderChangeFound"
        show
        theme="warning"
        class="text-center">
        {{ $t('order.puesc.orderChangeDetected') }}
      </d-alert>
      <d-row>
        <d-col cols="6">
          <strong>{{ $t('order.puesc.orderWeight') }}:</strong> {{ puescData.weight }} kg<br>
          <small>{{ $t('order.puesc.canChangeOrderWeight') }}</small>
        </d-col>
        <d-col cols="6">
          <d-button
            theme="success"
            @click.prevent="showPopup"
            class="d-block ml-auto">
            {{ $t('order.puesc.submitSent100') }}
          </d-button>
        </d-col>
      </d-row>

      <d-alert
        v-if="loadError"
        show
        class="mt-3 mb-3"
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>

      <table class="table mt-3 mb-3 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0" style="width: 100px;">{{ $t('order.puesc.createdAt') }}</th>
            <th scope="col" class="border-0" style="width: 200px;">{{ $t('order.puesc.status') }}</th>
            <th scope="col" class="border-0" style="width: 400px;">{{ $t('order.puesc.keys') }}</th>
            <th scope="col" class="border-0">{{ $t('order.puesc.message') }}</th>
          </tr>
        </thead>
        <tbody v-if="loadedItems">
          <tr
            v-for="(item, index) of items"
            :key="'item-' + index">
            <td class="align-middle">
              <template v-if="item.created_at">
                {{ item.created_at.slice(0,19).replace('T',' ') }}
              </template>
            </td>
            <td class="align-middle">
              <span :class="{
                'text-warning': item.status === 'PUESC_INTEGRATED',
                'text-primary': item.status === 'ADD_TO_PUESC',
                'text-success': item.status === 'PUESC_SUCCESS',
                'text-danger': item.status === 'ERROR'
              }">
                {{ $t('order.puesc.statuses.' + item.status) }}
              </span>
            </td>
            <td class="align-middle">
              <div v-if="item.sent_number">{{ $t('order.puesc.sentNumber') }}: <span class="text-primary">{{ item.sent_number }}</span></div>
              <div v-if="item.sender_key">{{ $t('order.puesc.senderKey') }}: <span class="text-primary">{{ item.sender_key }}</span></div>
              <div v-if="item.recipient_key">{{ $t('order.puesc.recipientKey') }}: <span class="text-primary">{{ item.recipient_key }}</span></div>
              <div v-if="item.carrier_key">{{ $t('order.puesc.carrierKey') }}: <span class="text-primary">{{ item.carrier_key }}</span></div>
            </td>
            <td class="align-middle">
              <small class="d-block">
                <template v-if="item.status === 'ERROR'">
                  {{ item.error_message }}
                </template>
                <template v-if="item.status === 'PUESC_SUCCESS'">
                  {{ item.info_message }}
                </template>
              </small>
            </td>
          </tr>
          <tr v-if="items.length === 0">
            <td
              colspan="7"
              class="text-center">
              {{ $t('order.puesc.noItemsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loadedItems" class="pb-3 pt-3 text-center">
         {{ $t('ui.dataLoading') }}&hellip;
      </div>
    </template>
    <template v-else>
      <d-alert
        show
        theme="warning"
        class="text-center">
        {{ $t('order.puesc.integrationNotAvailable') }}
      </d-alert>
    </template>

    <order-puesc-popup
      v-if="puescPopupVisible"
      :orderID="orderID"
      :addressData="addressData"
      :countries="countries"
      :customerData="customerData"
      :puescData="puescData" />
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import OrderPuescPopup from './OrderPuescPopup.vue';

export default {
  props: [
    'orderID',
    'addressData',
    'countries',
    'customerData',
    'puescData'
  ],
  components: {
    'order-puesc-popup': OrderPuescPopup
  },
  data () {
    return {
      items: [],
      loadedItems: false,
      loadError: false,
      orderChangeFound: false,
      puescPopupVisible: false
    };
  },
  mounted () {
    this.$bus.$on('order-puesc-product-id-or-qty-change', this.orderChangeDetected);
    this.$bus.$on('order-puesc-sent100-popup-close', this.closePuescPopup);
    this.$bus.$on('order-puesc-reload-items', this.loadItems);
    this.loadItems();
  },
  methods: {
    showPopup () {
      this.puescPopupVisible = true;
    },
    orderChangeDetected () {
      this.orderChangeFound = true;
    },
    closePuescPopup () {
      this.puescPopupVisible = false;
    },
    loadItems () {
      FormUtils.loadAdditionalData(this, {
        method: 'post',
        endpoint: '/puesc/items',
        loadedKey: 'loadedItems',
        outputKey: 'items',
        errorKey: 'loadError',
        params: {
          where: {
            order_id: this.orderID,
            method: 'ACCEPT_DOCUMENT'
          }
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('order-puesc-product-id-or-qty-change', this.orderChangeDetected);
    this.$bus.$off('order-puesc-sent100-popup-close', this.closePuescPopup);
    this.$bus.$off('order-puesc-reload-items', this.loadItems);
  }
}
</script>
